import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { Recipient } from 'src/app/models/recipients.model';
import { AnswerSwitchTypePipe } from '../answer-switch-type.pipe';
import { AnswerByRecipient } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { QueDatePipe } from 'src/app/pipes/date.pipe';

@Component({
    selector: 'que-answer-by-recipient',
    imports: [CommonModule, AnswerSwitchTypePipe, TranslateDirective, TranslatePipe, QueDatePipe],
    templateUrl: './answer-by-recipient.component.html',
    styleUrls: ['./answer-by-recipient.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswerByRecipientComponent implements OnInit {
  @Input() question?: Question;
  @Input() recipient?: Recipient;
  @Input() questionSource?: Question;
  @Input() answersByRecipient?: AnswerByRecipient[];
  @Input() isTextFree = false;
  #dataStore = inject(DataSummaryStore);
  #router = inject(Router);
  wasChange: boolean = false;
  showComparison$ = toSignal(this.#dataStore.showComparison$);
  id$ = toSignal(this.#dataStore.currentId$);

  myAnswerByRecipient?: AnswerByRecipient;
  gggg?: AnswerByRecipient[];
  eQuestionType = EQuestionType;

  ngOnInit() {
    if (this.answersByRecipient) {

      this.myAnswerByRecipient = this.answersByRecipient.find(x => x.recipient.id == this.recipient?.id);
    }
  }
  goToSummary() {
    if (this.id$()) {
      this.#dataStore.updateCurrentFilter(undefined);
      this.#dataStore.updateCurrentRecipientIdToFilter(undefined);
      this.#router.navigate([`data`, this.id$(), "summary"]);
    }
  }
}
